module.exports = __webpack_public_path__ + "img/en.19a3dc76.png";